import { render, staticRenderFns } from "./Aside.vue?vue&type=template&id=60c919be&scoped=true"
import script from "./Aside.vue?vue&type=script&lang=js"
export * from "./Aside.vue?vue&type=script&lang=js"
import style0 from "./Aside.vue?vue&type=style&index=0&id=60c919be&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60c919be",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/data/jenkins/.jenkins/workspace/overseas-platform_preview/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('60c919be')) {
      api.createRecord('60c919be', component.options)
    } else {
      api.reload('60c919be', component.options)
    }
    module.hot.accept("./Aside.vue?vue&type=template&id=60c919be&scoped=true", function () {
      api.rerender('60c919be', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/aside/Aside.vue"
export default component.exports